
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiProdottiDialog extends Serenity.EntityDialog<UtentiProdottiRow, any> {
        protected getFormKey() { return UtentiProdottiForm.formKey; }
        protected getIdProperty() { return UtentiProdottiRow.idProperty; }
        protected getLocalTextPrefix() { return UtentiProdottiRow.localTextPrefix; }
        protected getService() { return UtentiProdottiService.baseUrl; }
        protected getDeletePermission() { return UtentiProdottiRow.deletePermission; }
        protected getInsertPermission() { return UtentiProdottiRow.insertPermission; }
        protected getUpdatePermission() { return UtentiProdottiRow.updatePermission; }

        protected form = new UtentiProdottiForm(this.idPrefix);

    }
}